import { Dashboard } from "@assets/icons/dashboard";
import logoInvoiciaMobile from "@assets/images/logo mobile.png";
import logoInvoicia from "@assets/images/logo-invoicia-header.png";
import phones from "@assets/images/phones.png";
import transfFacture from "@assets/images/transformer_gestion_facture.png";
import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";

import imgSectionOneMobile from "@assets/images/img-home-sec1-mobile2.png";
import imgSectionOne from "@assets/images/img-home-sec1.png";
import { ResponsiveHeaderButton } from "@components/ButtonSignin/ButtonSignin";
import CustomButton from "@components/CustomButton/CustomButton";
import FAQ from "@components/Home/Faq/Faq";
import FooterHome from "@components/Home/FooterHome/FooterHome";
import InfoItem from "@components/Home/InfoItem/InfoItem";
import Pricing from "@components/Home/PrincingToggle/PrincingToggle";
import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import { StackInfo } from "@pages/home/home.style";
import { PATHS } from "config/paths";
import FacturationHome from "features/FacturationHome/FacturationHome";
import OurServices from "features/OurServices/OurServices";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetPacksQuery } from "store/pack/pack.api";
import AccordionImg from "../../components/Home/AccordionImg/AccordionImg";
import { infoItems } from "./Home.constants";
import "./home.scss";
const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const { data: packsData } = useGetPacksQuery();
  useEffect(() => {
    console.log("packsDaxxxxxxxxxta:", packsData);
  }, [packsData]);
  const scrollToPacks = () => {
    const packsSection = document.getElementById("packs");
    if (packsSection) {
      packsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack className="container-home">
      <Stack className="home-page">
        <Stack className="bg-header">
          <Stack className="header">
            {!isSmallDevice && (
              <Stack>
                <ToggleSwitch />
              </Stack>
            )}
            <Stack className="stack-header">
              {isSmallDevice ? (
                <img
                  alt=""
                  src={logoInvoiciaMobile}
                  style={{ width: "auto" }}
                />
              ) : (
                <img alt="" src={logoInvoicia} style={{ width: "200px" }} />
              )}

              <Stack className="btns-header">
                {user && (
                  <Button
                    onClick={() => {
                      navigate(PATHS.DASHBOARD_USER);
                    }}
                    className="btn-header"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0F84FF",
                    }}>
                    <Dashboard color={"#0f84ff"} />
                    {t("home.go_to_dashboard")}
                  </Button>
                )}
                {!user && (
                  <ResponsiveHeaderButton
                    onClick={() => {
                      navigate("/login");
                    }}
                    className="btn-header"
                    isSmallDevice={isSmallDevice}>
                    {t("home.btn_signin")}
                  </ResponsiveHeaderButton>
                )}
                {isSmallDevice && (
                  <Stack>
                    <ToggleSwitch />
                  </Stack>
                )}
                {!isSmallDevice && !user && (
                  <Button
                    onClick={scrollToPacks}
                    className="btn-header"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0F84FF",
                    }}>
                    {t("home.btn_signup")}
                  </Button>
                )}
              </Stack>
            </Stack>
          </Stack>

          <div className="my-5 ">
            <div className="row align-items-center texts-img-section">
              {/* Texte - 5 colonnes */}
              <div className="col-md-12 col-sm-12 col-xxl-6 col-lg-5">
                <Typography className="title">
                  {t("home.txt_header_section_1")}
                </Typography>
                <Typography className="title" color="#B7DAFF !important">
                  {t("home.txt_header_section_2")}
                </Typography>
                {!isSmallDevice && (
                  <Typography className="description">
                    {t("home.txt_description")}
                  </Typography>
                )}
                {!user && (
                  <Button
                    className="btn-header"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0F84FF",
                      margin: "2rem 0",
                    }}
                    onClick={() => {
                      navigate("/login");
                    }}>
                    {t("home.btn_signin")}
                  </Button>
                )}
              </div>

              {/* Image - 7 colonnes */}
              <div className="col-md-12 text-end col-sm-12 col-xxl-6 col-lg-6 image-mobile">
                <img
                  src={!isSmallDevice ? imgSectionOne : imgSectionOneMobile}
                  alt="section one"
                  className="img-fluid"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </Stack>

        <StackInfo className="infos" isServices={false}>
          {infoItems.map((item) => (
            <InfoItem
              key={item.key}
              description={item.description}
              img={item.img}
              title={item.title}
            />
          ))}
        </StackInfo>

        {!isSmallDevice && (
          <Stack sx={{ width: "50%", margin: "6rem auto" }}>
            <Typography className="about-us-title">
              {t("home.about_us_title")}
            </Typography>
            <Typography className="about-us-description">
              {t("home.about_us_description")}
            </Typography>
          </Stack>
        )}
        <OurServices isService={true} user={user} />

        <StackInfo
          className="infos"
          sx={{ marginBottom: "6rem" }}
          isServices={true}>
          {infoItems.map((item) => (
            <InfoItem
              key={item.key}
              description={item.description}
              img={item.img}
              title={item.title}
            />
          ))}
        </StackInfo>

        <div className=" my-5">
          <div className="row align-items-center rounded-4 px-3 facture-section">
            {/* Texte (col-md-4, col-12 en petit écran) */}
            <div className="col-12 col-md-4 mb-4 mb-md-0">
              <h2 className="facture-title mb-3">{t("home.facture_title")}</h2>
              <p className="facture-subtitle mb-3">
                {t("home.facture_sub_title")}
              </p>
              {!user && (
                <CustomButton
                  icon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 12L10 8L6 4"
                        stroke="#0F84FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  // onClick={() => navigate('/register')}
                  onClick={scrollToPacks}
                  text={"home.create_account"}
                  bgColor={"#ff7f5000"}
                  color={"#0F84FF"}
                  noHover={true}
                  style={{ margin: "0", padding: "0" }}
                />
              )}
            </div>

            <div className="col-12 col-md-8 text-center img-style">
              <img
                src={transfFacture}
                alt={t("home.facture_title")}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        <div className="row my-4">
          <div className="col-lg-6 col-md-12 col-sm-12">
            <img
              src={phones}
              alt="phones"
              className="img-fluid"
              style={{ width: "530px" }}
            />
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12">
            <FAQ />
          </div>
        </div>
        <div className="row" id="packs">
          <Pricing />
          <div className="col-lg-5 col-md-6 col-sm-12">
            {packsData?.data ? (
              <AccordionImg
                accordionData={packsData?.data}
                img={phones}
                sxGrid={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <FacturationHome user={user} />
        <FooterHome />
      </Stack>
    </Stack>
  );
};

export default Home;
